/* eslint-disable id-length */
import { Text, TextProps } from '@mantine/core';
import { ForwardedRef, ReactNode, forwardRef } from 'react';

export interface ITextProps extends TextProps {
  letterSpacing?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  component?: any;
  title?: string;
  children: string | ReactNode;
  isMasked?: boolean;
  onClick?: () => void;
}

export const ZorroText = forwardRef(
  (
    {
      letterSpacing = '-0.02em',
      component = 'span',
      c = 'zorroCoal.9',
      display = 'inline-block',
      size,
      fw = 400,
      children,
      isMasked = false,
      ...props
    }: ITextProps,
    ref: ForwardedRef<HTMLDivElement>
  ) => {
    const textClassNames = [isMasked ? 'fs-mask' : null].filter(
      (className): className is string => Boolean(className)
    );

    return (
      <Text
        component={component}
        style={{ letterSpacing }}
        display={display}
        size={size}
        ref={ref}
        fw={fw}
        c={c}
        classNames={{
          ...props.classNames,
          root: textClassNames.join(' '),
        }}
        {...props}
      >
        {children}
      </Text>
    );
  }
);

ZorroText.displayName = 'ZorroText';
